module.exports = __webpack_public_path__ + "img/屠宰加工企业.945442a6.png";